import {ShouldSkipLazyLoadFn} from 'app/interface';
import {parseHashUrl} from 'app/utils/urlStateElements/parseHashUrl';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn = ({config}) => {
    const cId = config?.cId;
    if (!cId) {
        return 'LOAD_LAZY';
    }

    const hashPath = window.location.hash.substring(1);
    if (!hashPath) {
        return 'LOAD_LAZY';
    }

    const hashState = parseHashUrl(hashPath);

    return hashState[cId]?.audio ? 'LOAD_EAGER' : 'LOAD_LAZY';
};
